import styles from "./CalenderWall_SingleImage.module.css";
import gallery_icon from "../../../assets/images/icons/gallery_ace.svg";
import { useDrag, useDrop } from "react-dnd";

const ItemType = "IMAGE";

const CalenderWallSingleImage = ({
  src,
  photoID,
  cancelImage,
  uploadSingle,
  handleImageDrop,
  index,
}) => {
  const [, ref] = useDrag({
    type: ItemType,
    item: { photoID },
  });

  const [, drop] = useDrop({
    accept: ItemType,
    drop: (item) => {
      console.log(item);
      handleImageDrop(item.photoID, photoID);
    },
  });
  return (
    <div className={styles.grid_item} ref={(node) => ref(drop(node))}>
      <div className={styles.image_body_main_div}>
        {/* Something to be said */}
        {src === "" && (
          <div
            onClick={(event) => {
              uploadSingle(1, photoID);
            }}
            // style={{ backgroundColor: "red" }}
            className={styles.upload_image_placeholder}
          >
            <img
              className={styles.upload_image_gallery_icon}
              src={gallery_icon}
              alt="top_gallery"
            />

            <div className={styles.upload_image_placeholder_text}>写真選択</div>
          </div>
        )}
        {src !== "" && (
          <img className={styles.image_body_image} src={src} alt={src} />
        )}
        {src !== "" && (
          <div
            onClick={() => {
              cancelImage(photoID);
            }}
            data-html2canvas-ignore="true"
            className={styles.cross_div}
          >
            <ion-icon className={styles.cross_icon} name="close"></ion-icon>
          </div>
        )}
      </div>
      <p className={styles.sheetText}>{index + 1 + " 枚目"}</p>
    </div>
  );
};
export default CalenderWallSingleImage;
